import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import I from 'components/I'
import { useContext } from 'react'
import Col from 'react-bootstrap/Col'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Row from 'react-bootstrap/Row'
import { Trans, useTranslation } from 'react-i18next'
import OrderContext from '../_context'

export default function GroupOrderRow() {
	const { t } = useTranslation()
	const order = useContext(OrderContext)

	if (!order.group_order) {
		return null
	}

	const dis = t('this')
	return <Row>
		<Col>
			<Icon icon="user-friends" fixedWidth/> {t('Group order')}
			<DropdownButton id="group-list" title={`#${order.group_order_id}`}
			                variant="light" size="sm" className="d-inline-block ml-1">
				{order.group_order.component_order_ids.map(({ id, number }) => (
					<Dropdown.Item href={`${id}`} key={id} disabled={id == order.id}>
						<Trans>
							Order #{{ number }} <I b>{{ is_this: (id == order.id)? t('({{x}})', { x: dis }) : null }}</I>{/* TODO this also doesn't create the actual tag? */}
						</Trans>
					</Dropdown.Item>
				))}
			</DropdownButton>
		</Col>
		<Col xs="auto">
			{t('{{guest_or_creator}}\'s order', { guest_or_creator: order.group_order_invitee_id? t('Guest') : t('Creator')})}
		</Col>
	</Row>
}
